import firebase from "firebase/compat/app";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";

export const uploadToStorage = (path: string, file: Blob): Promise<string> => {
  return new Promise((resolve, rejected) => {
    const storage = getStorage();
    const storageRef = ref(storage, path);
    const uploadTask = uploadBytesResumable(storageRef, file);

    const timeout = setTimeout(() => {
      uploadTask.cancel();
      rejected();
    }, 1000 * 10);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        console.log(snapshot);
      },
      (err) => {
        clearTimeout(timeout);
        rejected(err);
      },
      async () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          clearTimeout(timeout);
          resolve(downloadURL);
        });
      },
    );
  });
};
